import _ from 'lodash';
import React from 'react';
import projectStatuses from '~/lookups/project-statuses';
import MultiSelect from '../MultiSelect';

const options = _.values(projectStatuses);

export default function ProjectStatusFilter({ placeholder = 'Project Status', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
